import { shallowEqual } from 'react-redux';
import {
  connectMediaStore,
  useMMSelector,
  useMMDispatchActions,
} from './withOwnReduxStore';
import { PapiDeviation } from '@wix/da-papi-types';
import { onSelectableItemClick } from '../actions';
import { getSelectedDeviationIds, getSelectionLimit } from '../selectors';
import { getDeviationsByIds } from '../../redux/deviations/selectors';

export type EntityIdType = number | string;
export type WithSelectedDeviationsProps = {
  selectedCount: number;
  selectionLimit: number;
  selectedDeviationEntityIds: EntityIdType[];
  selectedDeviationIds: number[];
  selectedDeviations: PapiDeviation[];
  canSelectMore: boolean;
  onSelectableItemClick: (deviation: PapiDeviation) => any;
};

const mapStateToProps = (state, ownProps) => {
  const selectionLimit = getSelectionLimit(state) || ownProps.selectionLimit;
  const selectedDeviationEntityIds = getSelectedDeviationIds(state);
  const selectedDeviations = getDeviationsByIds(
    state,
    selectedDeviationEntityIds
  );
  return {
    selectionLimit,
    selectedDeviationEntityIds,
    selectedDeviationIds: selectedDeviationEntityIds.map(Number),
    selectedDeviations,
    selectedCount: selectedDeviations.length,
    canSelectMore: selectionLimit && selectedDeviations.length < selectionLimit,
  };
};

const mapDispatchToProps = { onSelectableItemClick };

export const useDeviationSelection = (): WithSelectedDeviationsProps => ({
  ...useMMSelector(state => mapStateToProps(state, {}), shallowEqual),
  ...useMMDispatchActions(mapDispatchToProps),
});

export default connectMediaStore(mapStateToProps, mapDispatchToProps);
